document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-quantity-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      const step = Number(input.step || 1);
      const minimum = Number(input.min || 1);
      const next = button.dataset.quantityButton === 'increase'
        ? Number(input.value) + step
        : Math.max(minimum, Number(input.value) - step);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('[data-motion-slider]').forEach((slider) => {
    const slides = [...slider.querySelectorAll('[data-motion-slide]')];
    const dots = [...slider.querySelectorAll('[data-motion-dot]')];
    const previous = slider.querySelector('[data-motion-prev]');
    const next = slider.querySelector('[data-motion-next]');
    const current = slider.querySelector('[data-motion-current]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplay = slider.dataset.autoplay === 'true' && !reducedMotion;
    const interval = Number(slider.dataset.interval || 6000);
    let activeIndex = 0;
    let timer;

    const showSlide = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const selected = slideIndex === activeIndex;
        slide.classList.toggle('is-active', selected);
        slide.setAttribute('aria-hidden', String(!selected));
      });
      dots.forEach((dot, dotIndex) => {
        const selected = dotIndex === activeIndex;
        dot.classList.toggle('is-active', selected);
        dot.setAttribute('aria-selected', String(selected));
      });
      if (current) current.textContent = String(activeIndex + 1).padStart(2, '0');
    };

    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (autoplay && slides.length > 1) {
        timer = window.setInterval(() => showSlide(activeIndex + 1), interval);
      }
    };

    previous?.addEventListener('click', () => {
      showSlide(activeIndex - 1);
      start();
    });
    next?.addEventListener('click', () => {
      showSlide(activeIndex + 1);
      start();
    });
    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => {
        showSlide(dotIndex);
        start();
      });
    });
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);
    start();
  });

  document.querySelectorAll('[data-product-tabs]').forEach((tabs) => {
    const buttons = [...tabs.querySelectorAll('[data-product-tab]')];
    const panels = [...tabs.querySelectorAll('[data-product-panel]')];

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        buttons.forEach((item, itemIndex) => {
          const selected = itemIndex === index;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', String(selected));
        });
        panels.forEach((panel, panelIndex) => {
          const selected = panelIndex === index;
          panel.classList.toggle('is-active', selected);
          panel.hidden = !selected;
        });
      });
    });
  });
});
